import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-preview-details',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-preview-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonPreviewDetailsComponent {}
